import React from "react";
import { FaClipboard, FaClipboardCheck, FaDownload, FaFileDownload } from "react-icons/fa";

type Props = {
    value: string | any,
    type: string,
    fileName: string
}



export default function DownloadButton({ value, type, fileName }: Props) {
  let [copied, setCopied] = React.useState(false);

  async function handleDownloadClick() {

    const fileContent = value;
    const blob = new Blob([fileContent], { type: type.toUpperCase() === "XML" ? 'text/xml' : 'text' });

    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = fileName;
    downloadLink.target = "_blank";

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

  }


  React.useEffect(() => {
    if (copied) {
      let id = setTimeout(() => {
        setCopied(false);
      }, 2000);
      return () => clearTimeout(id);
    }
  }, [copied]);

  return (
    <button
        className="m-4 rounded-md bg-indigo-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
        title="Download the file"
      onClick={() => {
        handleDownloadClick().catch(err => console.error(err));
        setCopied(true);
      }}
    >
      {copied ? <span><FaFileDownload className="float-left m-1 mr-2" /> Downloading...</span> : <span><FaDownload className="float-left m-1 mr-2" /> Download {type}</span>}
    </button>
  );
}

